(function () {
  function setButtonState(button, state, label) {
    var labelEl = button.querySelector('[data-pdp-reset-coupon-copy-label]');
    if (labelEl) {
      labelEl.textContent = label;
    }

    button.classList.toggle('is-copied', state === 'copied');
    button.classList.toggle('is-error', state === 'error');
  }

  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        successful ? resolve() : reject(new Error('Fallback copy failed'));
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return fallbackCopy(text);
      });
    }

    return fallbackCopy(text);
  }

  function getCouponText(instance, key, fallback) {
    return instance.dataset[key] || fallback;
  }

  function restoreButton(instance, button) {
    var status = instance.querySelector('[data-pdp-reset-coupon-status]');

    window.clearTimeout(instance.pdpResetCouponTimer);
    setButtonState(button, 'idle', getCouponText(instance, 'copyLabel', 'Copy'));
    button.setAttribute('aria-label', getCouponText(instance, 'copyAria', 'Copy coupon code'));

    if (status) {
      status.textContent = '';
    }
  }

  function initCoupon(instance) {
    if (instance.dataset.pdpResetCouponReady === 'true') {
      return;
    }

    var button = instance.querySelector('[data-pdp-reset-coupon-copy]');
    var status = instance.querySelector('[data-pdp-reset-coupon-status]');
    var code = (instance.dataset.couponCode || '').trim();
    var resetMs = parseInt(instance.dataset.resetMs, 10);

    if (!button || !code) {
      return;
    }

    if (!resetMs || resetMs < 0) {
      resetMs = 5000;
    }

    instance.dataset.pdpResetCouponReady = 'true';

    button.addEventListener('click', function () {
      window.clearTimeout(instance.pdpResetCouponTimer);

      copyText(code)
        .then(function () {
          setButtonState(button, 'copied', getCouponText(instance, 'copiedLabel', 'Copied!'));
          button.setAttribute('aria-label', getCouponText(instance, 'copiedAria', 'Coupon code copied'));

          if (status) {
            status.textContent = getCouponText(instance, 'copiedLabel', 'Copied!');
          }

          instance.pdpResetCouponTimer = window.setTimeout(function () {
            restoreButton(instance, button);
          }, resetMs);
        })
        .catch(function () {
          setButtonState(button, 'error', getCouponText(instance, 'copyLabel', 'Copy'));
          button.setAttribute('aria-label', getCouponText(instance, 'errorAria', 'Copy coupon code failed, try again'));

          if (status) {
            status.textContent = getCouponText(instance, 'errorLabel', 'Try again');
          }

          instance.pdpResetCouponTimer = window.setTimeout(function () {
            restoreButton(instance, button);
          }, resetMs);
        });
    });
  }

  function initAllCoupons() {
    document.querySelectorAll('[data-pdp-reset-coupon]').forEach(initCoupon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCoupons);
  } else {
    initAllCoupons();
  }

  document.addEventListener('shopify:section:load', initAllCoupons);
})();
